<template>
  <div class="hero-area slider-navigation-1">
    <!-- align-items-center -->
    <div v-for="heroArea in heroAreaData" class="single-hero-item d-flex "
         :style="{backgroundImage:'url(' + heroArea.pic + ')'}">
      <div class="container">
        <div class="row">
          <div class="col-xl-6 col-lg-8 col-md-9 offset-xl-1 offset-0">
            <div class="hero-content">
              <h1>{{heroArea.name}}</h1>
              <p>{{heroArea.note}}</p>
              <a :href="heroArea.url" class="sn-button">
                <span>View Now</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
    import {getLAdvertise} from '@/api/advertise'
    export default {
        name: "hero-area",
        data(){
          return {
            heroAreaData:[]
          }
        },
        beforeCreate(){
          let _this = this
          getLAdvertise(1).then(res=>{
            if(res.data.code===200) {
              _this.heroAreaData = res.data.data
              setTimeout(function(){
                $('.hero-area').slick({
                  slidesToShow: 1,
                  autoplay: true,
                  autoplaySpeed: 8000,
                  adaptiveHeight: true,
                  dots: false,
                  arrows: true,
                  fade: true,
                  easing: 'ease-in-out',
                  speed: 1000,
                  prevArrow: '<span class="slider-navigation slider-navigation-prev"><i class="fa fa-angle-left"></i></span>',
                  nextArrow: '<span class="slider-navigation slider-navigation-next"><i class="fa fa-angle-right"></i></span>',
                })
              }, 500)
            }
          })
        }
    }
</script>

<style scoped>

</style>
